import { ROUTES_PATH } from "shared/constants/routesPath";
import Home from "pages/Home";
import Gift from "pages/Gift";
import Registration from "pages/Registration";
import Account from "pages/Account";
import About from "pages/About";
import MyGifts from "pages/MyGifts";
import Invite from "pages/Invite";
import History from "pages/History";
import Support from "pages/Support";
import Search from "pages/Search";
import SelectMall from "pages/SelectMall";
import Profile from "pages/Profile";
import MyGift from "pages/MyGift";
import News from "pages/News";
import Scan from "pages/Scan";
import Statuses from "pages/Statuses";

export const routesArray = [
  {
    path: ROUTES_PATH.HOME,
    element: <Home />,
  },

  {
    path: ROUTES_PATH.SEARCH,
    element: <Search />,
  },

  {
    path: ROUTES_PATH.SELECT_MALL,
    element: <SelectMall />,
  },

  {
    path: ROUTES_PATH.GIFT,
    element: <Gift />,
  },

  {
    path: ROUTES_PATH.REGISTRATION,
    element: <Registration />,
  },

  {
    path: ROUTES_PATH.ACCOUNT,
    element: <Account />,
  },

  {
    path: ROUTES_PATH.ABOUT,
    element: <About />,
  },

  {
    path: ROUTES_PATH.MY_GIFTS,
    element: <MyGifts />,
  },

  {
    path: ROUTES_PATH.INVITE,
    element: <Invite />,
  },

  {
    path: ROUTES_PATH.HISTORY,
    element: <History />,
  },

  {
    path: ROUTES_PATH.SUPPORT,
    element: <Support />,
  },

  {
    path: ROUTES_PATH.PROFILE,
    element: <Profile />,
  },

  {
    path: ROUTES_PATH.MY_GIFT,
    element: <MyGift />,
  },

  {
    path: ROUTES_PATH.NEWS,
    element: <News />,
  },

  {
    path: ROUTES_PATH.SCAN,
    element: <Scan />,
  },

  {
    path: ROUTES_PATH.STATUSES,
    element: <Statuses />,
  },
];

export const whitePages = [
  ROUTES_PATH.REGISTRATION,
  ROUTES_PATH.ABOUT,
  ROUTES_PATH.MY_GIFTS,
  ROUTES_PATH.INVITE,
  ROUTES_PATH.HISTORY,
  ROUTES_PATH.SUPPORT,
  ROUTES_PATH.SELECT_MALL,
  ROUTES_PATH.PROFILE,
  ROUTES_PATH.STATUSES,
];

export const authPages = [
  ROUTES_PATH.ACCOUNT,
  ROUTES_PATH.ABOUT,
  ROUTES_PATH.MY_GIFTS,
  ROUTES_PATH.HISTORY,
  ROUTES_PATH.PROFILE,
  ROUTES_PATH.SUPPORT,
  ROUTES_PATH.INVITE,
];
